// extracted by mini-css-extract-plugin
module.exports = {"circle":"setNewPasswordError_circle__2WMGp"};